import React from 'react';
import PropTypes from 'prop-types';
import HoverTooltip from '@Components/HoverTooltip';
import { ButtonWithIcon } from '@els/els-react--button';
import noop from 'lodash/noop';
import ReactDOMServer from 'react-dom/server';
import { PopupRow } from './ProjectParametersUtils';
import SmilesSection from './SmilesSection/SmilesSection';

function PredictedParametersIktosIntermediates({ params, onParamsChanged }) {
  return (
    <div className="pp-iktos-intermediates">
      <PopupRow className="rs-column-subheader">
        Enter intermediates
        <HoverTooltip
          id="info-tooltip-intermediates"
          tooltip={ReactDOMServer.renderToString(
            <div className="rs-tooltip-big__content">
              <div className="info-tooltip-content-list-item">
                Iktos-powered Reaxys predictive retrosynthesis allows users to specify intermediates to be included or excluded. If a route
                contains a structure listed in the &quot;Exclude substructures&quot; section, it will be omitted. Conversely, if structures
                are listed in the &quot;Include substructures&quot; section, only routes containing matching structures will be returned.
                These input structures can be atoms, fragments, functional groups, or complete structures. They can be entered as SMILES
                strings manually or via copy/paste, with up to 10 strings allowed, separated by commas.
              </div>
              <div className="info-tooltip-content-list-item">
                Examples (click the + icon or hit return after adding the SMILES strings):
                <ul className="info-tooltip-content-list init-counter">
                  <li className="info-tooltip-content-list-item bullet-dot">
                    type in &quot;Br&quot; in &quot;Exclude substructure&quot; line to exclude all routes with Br-containing structures.
                  </li>
                  <li className="info-tooltip-content-list-item bullet-dot">
                    type in &quot;N(=O)=O&quot; in &quot;Exclude substructure&quot; line to exclude all routes with NO2-containing
                    compounds.
                  </li>
                  <li className="info-tooltip-content-list-item bullet-dot">
                    type in &quot;C1=CC=NC=C1&quot; in &quot;Exclude substructure&quot; line to exclude all routes containing pyridine and
                    all pyridine-containing compounds.
                  </li>
                </ul>
              </div>
            </div>
          )}
          trigger="click">
          <ButtonWithIcon className="u-els-margin-left-1o2" sprite="InformationOutlineCircle" iconOnly type="link" onClick={noop}>
            Enter Intermediates Information
          </ButtonWithIcon>
        </HoverTooltip>
      </PopupRow>
      <SmilesSection
        section="include"
        smiles={params.includeSubstructures || []}
        setSmiles={(includeSmiles) => onParamsChanged({ includeSubstructures: includeSmiles })}
      />
      <SmilesSection
        section="exclude"
        smiles={params.excludeSubstructures || []}
        setSmiles={(excludeSmiles) => onParamsChanged({ excludeSubstructures: excludeSmiles })}
      />
    </div>
  );
}

PredictedParametersIktosIntermediates.defaultProps = {
  params: {},
  onParamsChanged: () => null,
};

PredictedParametersIktosIntermediates.propTypes = {
  onParamsChanged: PropTypes.func,
  params: PropTypes.object,
};

export default PredictedParametersIktosIntermediates;
